// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"523":"cb1608f2","532":"styles","691":"component---src-pages-index-tsx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"523":"e56b3f1501abfabc5b9d","532":"1763888e73d9c2a375b6","691":"effae5e381d430efcab4","883":"4958efeaa12ed512b431"}[chunkId] + ".js";
};